
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckTutorial } from './providers/check-tutorial.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/tutorial',
    pathMatch: 'full'
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignUpModule)
  },
  // {
  //   path: 'app',
  //   // loadChildren: () => import('./pages/tabs-page/tabs-page.module').then(m => m.TabsModule)
  //   children: [
  //     {
  //       path: 'contacts',
  //       // component: ChatRoomListPage,
  //       loadChildren: () => import('./pages/contact-list/contact-list.module').then(m => m.ContactListModule)
  //     },
  //     {
  //       path: 'room/:roomId/:type',
  //       loadChildren: () => import('./pages/chat-room/chat-room.module').then(m => m.ChatRoomModule)
  //     }
  //   ]
  // },
  {
    path: 'contacts',
    // component: ChatRoomListPage,
    loadChildren: () => import('./pages/contact-list/contact-list.module').then(m => m.ContactListModule)
  },
  {
    path: 'room/:roomId/:type',
    loadChildren: () => import('./pages/chat-room/chat-room.module').then(m => m.ChatRoomModule)
  },
  {
    path: 'app/room/:roomId/:type/:token',
    loadChildren: () => import('./pages/chat-room/chat-room.module').then(m => m.ChatRoomModule)
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialModule),
    canLoad: [CheckTutorial]
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
